<template>
  <div>
    <div class="section-desc">
      {{ $t('알림톡 발송 정책. 마스터 토글이 OFF면 모든 하위 알림이 발송되지 않습니다.') }}
    </div>

    <el-row>
      <el-col :md="24">
        <el-form-item :label="$t('주문관리 알림톡 마스터')">
          <el-switch v-model="inputForm.alarmYn"></el-switch>
        </el-form-item>
      </el-col>

      <el-col :md="12">
        <el-form-item :label="$t('주문 접수/취소 알림톡')">
          <el-switch v-model="inputForm.orderReceiptCancelAlarmYn" :disabled="!inputForm.alarmYn"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item :label="$t('수령 안내 알림톡')">
          <el-switch v-model="inputForm.orderReadyAlarmYn" :disabled="!inputForm.alarmYn"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item :label="$t('배달 완료 알림톡')">
          <el-switch v-model="inputForm.deliveryCompleteAlarmYn" :disabled="!inputForm.alarmYn"></el-switch>
          <div class="field-hint">
            {{ $t('배달 완료 시점에 고객에게 알림톡을 발송합니다. 외부 배달앱 주문은 제외됩니다.') }}
          </div>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item :label="$t('포인트 적립 알림톡')">
          <el-switch v-model="inputForm.pointAddAlarmYn" :disabled="!inputForm.alarmYn"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item :label="$t('포인트 사용 알림톡')">
          <el-switch v-model="inputForm.pointUseAlarmYn" :disabled="!inputForm.alarmYn"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row class="section-divider">
      <el-col :md="12">
        <el-form-item :label="$t('오더톡 요청사항 필드')">
          <el-switch v-model="inputForm.ordertalkRequestEnabled"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item :label="$t('수저포크 안 받기 체크박스')">
          <el-switch v-model="inputForm.cutleryRequestEnabled"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row v-if="isInternalAdmin" class="section-divider">
      <el-col :md="24">
        <el-form-item :label="$t('오더톡 보이지 않기')">
          <el-switch v-model="inputForm.hideInOrdertalk"></el-switch>
          <div class="field-hint">
            {{
              $t(
                'ON 시 qr2-web에서 매장 직접 접근 차단 + 위치 기반 매장 검색 결과에서 제외됩니다. 오더엔 관리자(admin·mng) 전용.'
              )
            }}
          </div>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { adminRoleMixin } from '@/mixins/adminRoleMixin'

/**
 * 「오더톡 보이지 않기」 스위치는 **오더엔 내부 관리자**만 본다([adminRoleMixin] 의 `isInternalAdmin`).
 *
 * 종전에는 `authId === 'mng'` 정확 일치라 `admin` 은 같은 값을 「비활성 매장 관리」의 일괄 표면
 * (`POST /store/hideInOrdertalk/bulk`)에서는 바꿀 수 있는데 매장 폼에서는 보지도 못했다. 서버의
 * 매장 저장(`PUT /store/mng/*`)도 두 역할이 함께 가지므로 두 표면이 같은 답을 해야 한다.
 */
export default {
  mixins: [adminRoleMixin],
  props: ['value', 'formError'],
  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
}
</script>

<style scoped>
.el-col {
  padding: 4px;
}
.section-desc {
  color: #909399;
  font-size: 13px;
  margin-bottom: 8px;
  padding: 0 4px;
}
.section-divider {
  border-top: 1px solid #ebeef5;
  margin-top: 8px;
  padding-top: 8px;
}
.field-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>
